import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Legal.css';

function Terms() {
  const { t } = useTranslation();
  const points = [
    'Global Mobility Group LLC te ayuda a gestionar tu solicitud de inmigracion en Espana.',
    'No garantizamos la aprobacion; las decisiones son de las autoridades espanolas.',
    'Debes proporcionar informacion veraz y documentos autenticos.',
    'Honorarios: 250EUR por persona (IVA incluido cuando aplique). Las tasas administrativas gubernamentales no estan incluidas y se comunican por separado.',
    'Puedes cancelar en cualquier momento contactando a legal@globalmobility.law.',
  ];

  return (
    <div className="mvp-legal-page">
      <div className="mvp-legal-card">
        <h1>{t('legal.terms', 'Terms')}</h1>
        <p className="mvp-legal-placeholder">Aqui tienes un resumen de los terminos que rigen nuestros servicios:</p>
        <ul className="mvp-legal-placeholder">
          {points.map((point) => (
            <li key={point}>{point}</li>
          ))}
        </ul>
        <p className="mvp-legal-placeholder">
          <a href="https://globalmobility.law/terminos-servicio" target="_blank" rel="noopener noreferrer">
            Ver documento completo
          </a>
        </p>
        <Link to="/" className="mvp-legal-back">{t('legal.goHome', 'Go to home')}</Link>
      </div>
    </div>
  );
}

export default Terms;
